import { useTranslations } from "@acto/web-common/locales";
import { MetricCard } from "../../ui";
import { styled } from "@pigment-css/react";
import type { KpiValue } from "@acto/taskpane/core/domain/TeamEmployee";
import { useCurrencyContext } from "@acto/taskpane/core/contexts/TenantSettingsContext";
import { formatCurrency, formatProfitWithMargin } from "../../../../utils/formatters";

const Grid = styled("div")(({ theme }) => ({
  position: "relative",
  width: "100%",
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: theme.managementView.spacing[24],
}));

interface EmployeeMetricsProps {
  revenue: KpiValue;
  margin: KpiValue;
  profit: KpiValue;
  locale: string;
  showTrends?: boolean;
}

export const EmployeeMetrics = ({ revenue, margin, profit, locale, showTrends = true }: EmployeeMetricsProps) => {
  const t = useTranslations();
  const currency = useCurrencyContext();

  return (
    <Grid>
      <MetricCard
        label={t("managementView.employee.revenue")}
        value={formatCurrency(revenue.totalValue, locale, currency)}
        change={showTrends ? (revenue.percentageChange ?? 0) : null}
      />
      <MetricCard
        label={t("managementView.employee.margin")}
        value={formatProfitWithMargin(profit.totalValue, margin.totalValue, locale, currency)}
        change={showTrends ? (profit.percentageChange ?? 0) : null}
      />
    </Grid>
  );
};
